import { FunctionComponent, useState } from 'react'

import ApiKeyDialog from './ApiKeyDialog'
import { MenuItem } from '@mui/material'

interface Props {
  handleClose: Function
}

const ShowApiKeyMenuItem: FunctionComponent<Props> = ({ handleClose }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClickOpen = () => {
    handleClose()
    setIsOpen(true)
  }

  const handleCloseDialog = () => {
    setIsOpen(false)
  }

  return (
    <>
      <MenuItem onClick={handleClickOpen} data-testid="show-api-key">
        API Key
      </MenuItem>
      <ApiKeyDialog isOpen={isOpen} handleClose={handleCloseDialog} />
    </>
  )
}

export default ShowApiKeyMenuItem
